import { useQuery } from 'react-query';
import ReportService from 'reports/services';

export function useReport(reportId: number) {
  return useQuery(
    ['report', reportId],
    (key: string, id: number) =>
      id ? ReportService.get(id) : Promise.resolve(null),
    { refetchOnMount: false, refetchOnWindowFocus: false }
  );
}

export function useReportData(reportId: number, page: number) {
  return useQuery(
    ['report-data', reportId, page],
    (key: string, id: number, page: number) => ReportService.data(id, { page }),
    { refetchOnMount: false, refetchOnWindowFocus: false }
  );
}
